module Meevo.Plugins.Client {
    class NamePhoneDuplicateWarningModal {
        public clients: Model.Client[];
        public selectedClientId: string;

        static $inject = ['$mdDialog'];

        constructor(protected $mdDialog: angular.material.IDialogService) {
        }

        /**
         * Close modal window
         * */
        public cancel(): void {
            this.$mdDialog.cancel();
        }

        public yes(): void {
            if (!this.selectedClientId) {
                return;
            }

            let selectedClient: Model.Client = this.clients.filter(client => client.id === this.selectedClientId)[0];
            this.$mdDialog.hide(selectedClient);
        }
    }

    angular.module('meevo.plugins.client')
        .controller('meevo.plugins.client.NamePhoneDuplicateWarningModal', NamePhoneDuplicateWarningModal);
}
